import React from 'react';
import { Navigate } from 'react-router-dom';
import type { ApiUserRole } from '@/core/generated/api';
import { useAuth } from '@/entities/Auth/store';
import { RequestLoading } from '@/shared/ui/RequestState';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: readonly ApiUserRole[];
}

/** Ограничивает маршрут аутентификацией и разрешёнными ролями. */
export const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
    const isAuthenticated = useAuth((state) => state.isAuthenticated);
    const isCheckingAuth = useAuth((state) => state.isCheckingAuth);
    const roleCode = useAuth((state) => state.roleCode);

    if (isCheckingAuth) {
        return <RequestLoading message="Проверка авторизации..." />;
    }

    if (!isAuthenticated) {
        return <Navigate
            to="/auth"
            replace
        />;
    }

    if (allowedRoles && (!roleCode || !allowedRoles.includes(roleCode))) {
        return <Navigate
            to="/"
            replace
        />;
    }

    return <>{children}</>;
};
